<template>
  <span class="stats-announcement">
    <ElButton
      class="stats-announcement__button"
      type="primary"
      @click="showAnnouncementModal"
    >
      {{ $t('APP.STATS.ANNOUNCEMENT_BUTTON') }}
      <i class="el-icon-message-solid" />
    </ElButton>
    <StatsAnnouncementModal
      v-model="announcementModalVisibility"
      :title="title"
      :text="text"
    />
  </span>
</template>

<script>
import StatsAnnouncementModal from './StatsAnnouncementModal';

export default {
  name: 'StatsAnnouncement',
  components: {
    StatsAnnouncementModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      announcementModalVisibility: false,
    };
  },
  methods: {
    showAnnouncementModal() {
      this.announcementModalVisibility = true;
    },
  },
};
</script>
<style lang="scss">
.stats-announcement {
  &__button {
    padding: $global-margin / 2;
    border-radius: 500px;
    background-color: transparent !important;
    color: $lb-color-primary;

    &:hover {
      background-color: $lb-color-primary !important;
    }

    &:focus {
      background-color: transparent !important;
      color: $lb-color-primary !important;
    }
  }
}
</style>
